import { getDevicePlatform } from '../helpers/devicePlatform';

/**
 * Mints a mobile handoff (web login) refresh token for the in-app browser account-creation
 * flow, via a server-side endpoint that derives the user id from the Django session. The numeric
 * user id is not available client-side for platgen users (it's only in the session), so the mint
 * is done server-side. Requested at the LAST onboarding step, right before the native deep-link
 * redirect. The token is a refresh-token credential, so it is never logged or persisted.
 *
 * @returns the handoff token string, or null if it could not be minted.
 */
export async function requestHandoffToken(): Promise<string | null> {
  const devicePlatform = getDevicePlatform();
  const productId = window.product_id || 1;
  try {
    const response = await fetch(
      `/api/handoff_token?device_platform=${encodeURIComponent(
        devicePlatform
      )}&product_id=${productId}`,
      { method: 'GET', credentials: 'same-origin' }
    );
    const data = await response.json();
    const token =
      data && typeof data.handoff_token === 'string'
        ? data.handoff_token
        : null;
    return token;
  } catch (exception) {
    return null;
  }
}
